export default __webpack_public_path__ + "static/media/oil.874fe7cf.svg";